/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ip_Not_RecordedInputs */

const th_ip_not_recorded = /** @type {(inputs: Ip_Not_RecordedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่ได้บันทึกหมายเลข IP`)
};

const en_ip_not_recorded = /** @type {(inputs: Ip_Not_RecordedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IP not recorded`)
};

const ja_ip_not_recorded = /** @type {(inputs: Ip_Not_RecordedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IPアドレスの記録なし`)
};

const zh_ip_not_recorded = /** @type {(inputs: Ip_Not_RecordedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未记录 IP`)
};

const es_ip_not_recorded = /** @type {(inputs: Ip_Not_RecordedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IP no registrada`)
};

const pt_ip_not_recorded = /** @type {(inputs: Ip_Not_RecordedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IP não registrado`)
};

const id_ip_not_recorded = /** @type {(inputs: Ip_Not_RecordedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IP tidak dicatat`)
};

const fr_ip_not_recorded = /** @type {(inputs: Ip_Not_RecordedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IP non enregistrée`)
};

const tl_ip_not_recorded = /** @type {(inputs: Ip_Not_RecordedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi naitala ang IP`)
};

const vi_ip_not_recorded = /** @type {(inputs: Ip_Not_RecordedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không ghi IP`)
};

const ko_ip_not_recorded = /** @type {(inputs: Ip_Not_RecordedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IP 미기록`)
};

const de_ip_not_recorded = /** @type {(inputs: Ip_Not_RecordedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IP nicht erfasst`)
};

const ru_ip_not_recorded = /** @type {(inputs: Ip_Not_RecordedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IP не записан`)
};

const tr_ip_not_recorded = /** @type {(inputs: Ip_Not_RecordedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IP kaydedilmedi`)
};

const it_ip_not_recorded = /** @type {(inputs: Ip_Not_RecordedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IP non registrato`)
};

const pl_ip_not_recorded = /** @type {(inputs: Ip_Not_RecordedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie zapisano IP`)
};

const uk_ip_not_recorded = /** @type {(inputs: Ip_Not_RecordedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IP не записано`)
};

const hi_ip_not_recorded = /** @type {(inputs: Ip_Not_RecordedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IP दर्ज नहीं`)
};

const ar_ip_not_recorded = /** @type {(inputs: Ip_Not_RecordedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يُسجَّل عنوان IP`)
};

const ms_ip_not_recorded = /** @type {(inputs: Ip_Not_RecordedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IP tidak direkodkan`)
};

const bn_ip_not_recorded = /** @type {(inputs: Ip_Not_RecordedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IP নথিভুক্ত নয়`)
};

const zh_tw2_ip_not_recorded = /** @type {(inputs: Ip_Not_RecordedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未記錄 IP`)
};

const zh_hk2_ip_not_recorded = /** @type {(inputs: Ip_Not_RecordedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未記錄 IP`)
};

const ur_ip_not_recorded = /** @type {(inputs: Ip_Not_RecordedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IP درج نہیں`)
};

const fa_ip_not_recorded = /** @type {(inputs: Ip_Not_RecordedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IP ثبت نشده`)
};

const sw_ip_not_recorded = /** @type {(inputs: Ip_Not_RecordedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IP haijarekodiwa`)
};

const nl_ip_not_recorded = /** @type {(inputs: Ip_Not_RecordedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IP niet vastgelegd`)
};

/**
* | output |
* | --- |
* | "IP not recorded" |
*
* @param {Ip_Not_RecordedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const ip_not_recorded = /** @type {((inputs?: Ip_Not_RecordedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ip_Not_RecordedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_ip_not_recorded(inputs)
	if (locale === "ja") return ja_ip_not_recorded(inputs)
	if (locale === "zh") return zh_ip_not_recorded(inputs)
	if (locale === "es") return es_ip_not_recorded(inputs)
	if (locale === "pt") return pt_ip_not_recorded(inputs)
	if (locale === "id") return id_ip_not_recorded(inputs)
	if (locale === "fr") return fr_ip_not_recorded(inputs)
	if (locale === "tl") return tl_ip_not_recorded(inputs)
	if (locale === "vi") return vi_ip_not_recorded(inputs)
	if (locale === "ko") return ko_ip_not_recorded(inputs)
	if (locale === "de") return de_ip_not_recorded(inputs)
	if (locale === "ru") return ru_ip_not_recorded(inputs)
	if (locale === "tr") return tr_ip_not_recorded(inputs)
	if (locale === "it") return it_ip_not_recorded(inputs)
	if (locale === "pl") return pl_ip_not_recorded(inputs)
	if (locale === "uk") return uk_ip_not_recorded(inputs)
	if (locale === "hi") return hi_ip_not_recorded(inputs)
	if (locale === "ar") return ar_ip_not_recorded(inputs)
	if (locale === "ms") return ms_ip_not_recorded(inputs)
	if (locale === "bn") return bn_ip_not_recorded(inputs)
	if (locale === "zh-TW") return zh_tw2_ip_not_recorded(inputs)
	if (locale === "zh-HK") return zh_hk2_ip_not_recorded(inputs)
	if (locale === "ur") return ur_ip_not_recorded(inputs)
	if (locale === "fa") return fa_ip_not_recorded(inputs)
	if (locale === "sw") return sw_ip_not_recorded(inputs)
	if (locale === "nl") return nl_ip_not_recorded(inputs)
	return en_ip_not_recorded(inputs)
});